var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssociateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "People alt",
    clipPath: "url(#clip0_2741_116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7833 21.8834C30.0667 23.4334 31.6667 25.5334 31.6667 28.3334V33.3334H38.3333V28.3334C38.3333 24.7 32.3833 22.55 27.7833 21.8834Z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15 20C18.6819 20 21.6667 17.0153 21.6667 13.3334C21.6667 9.65146 18.6819 6.66669 15 6.66669C11.3181 6.66669 8.33337 9.65146 8.33337 13.3334C8.33337 17.0153 11.3181 20 15 20Z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 20C28.6833 20 31.6667 17.0167 31.6667 13.3334C31.6667 9.65002 28.6833 6.66669 25 6.66669C24.2167 6.66669 23.4833 6.83335 22.7833 7.06669C24.1667 8.78335 25 10.9667 25 13.3334C25 15.7 24.1667 17.8834 22.7833 19.6C23.4833 19.8334 24.2167 20 25 20Z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 21.6667C10.55 21.6667 1.66669 23.9 1.66669 28.3334V33.3334H28.3334V28.3334C28.3334 23.9 19.45 21.6667 15 21.6667Z",
    fill: "#FFFFFF"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2741_116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssociateIcon);
export default __webpack_public_path__ + "static/media/associate_icon.239c0d2f8db016618f6f6895b28fb81a.svg";
export { ForwardRef as ReactComponent };